import React from 'react';
import {
  BreakPointHooks,
  breakpointsTailwind,
} from '@react-hooks-library/core';
import { useContextSelector, createContext } from 'use-context-selector';

const BreakpointContext = createContext();

export function BreakpointProvider({ children }) {
  const breakpoints = BreakPointHooks(breakpointsTailwind);
  return (
    <BreakpointContext.Provider value={breakpoints}>
      {children}
    </BreakpointContext.Provider>
  );
}

export function useBreakpointHooks(selector = (breakpoints) => breakpoints) {
  return useContextSelector(BreakpointContext, selector);
}
